// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
let RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");
let PropertiesPageRelayInventoryRefetchQuery_graphql = require("./PropertiesPageRelayInventoryRefetchQuery_graphql.bs.js");

let Types = {};

function unwrap_fragment_searchForSaleInventory_edges_node(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, [
    "DevelopmentProject",
    "DevelopmentProjectSampleUnit",
    "ForSalePropertyV5"
  ]);
}

let fragmentConverter = {"__root":{"searchForSaleInventory_edges_node_ForSalePropertyV5":{"f":""},"searchForSaleInventory_edges_node_DevelopmentProjectSampleUnit":{"f":""},"searchForSaleInventory_edges_node_DevelopmentProject":{"f":""},"searchForSaleInventory_edges_node":{"u":"fragment_searchForSaleInventory_edges_node"}}};

let fragmentConverterMap = {
  fragment_searchForSaleInventory_edges_node: unwrap_fragment_searchForSaleInventory_edges_node
};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, fragmentConverterMap, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: fragmentConverterMap,
  convertFragment: convertFragment
};

let Utils = {};

function makeNode(rescript_graphql_node_PropertiesPageRelayInventoryRefetchQuery) {
  return ((function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "areaIds"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "before"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "forSalePropertyTypes"
    },
    {
      "kind": "RootArgument",
      "name": "forSaleStatuses"
    },
    {
      "kind": "RootArgument",
      "name": "keywords"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "last"
    },
    {
      "kind": "RootArgument",
      "name": "maxBeds"
    },
    {
      "kind": "RootArgument",
      "name": "maxPrice"
    },
    {
      "kind": "RootArgument",
      "name": "minBeds"
    },
    {
      "kind": "RootArgument",
      "name": "minPrice"
    },
    {
      "kind": "RootArgument",
      "name": "offMlsOnly"
    },
    {
      "kind": "RootArgument",
      "name": "sortOrder"
    },
    {
      "kind": "RootArgument",
      "name": "useForSaleInventory"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [],
      "operation": rescript_graphql_node_PropertiesPageRelayInventoryRefetchQuery
    }
  },
  "name": "PropertiesPageRelayInventory_query",
  "selections": [
    {
      "condition": "useForSaleInventory",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "after",
              "variableName": "after"
            },
            {
              "kind": "Variable",
              "name": "areaIds",
              "variableName": "areaIds"
            },
            {
              "kind": "Variable",
              "name": "before",
              "variableName": "before"
            },
            {
              "kind": "Variable",
              "name": "first",
              "variableName": "first"
            },
            {
              "kind": "Variable",
              "name": "keywords",
              "variableName": "keywords"
            },
            {
              "kind": "Variable",
              "name": "last",
              "variableName": "last"
            },
            {
              "kind": "Variable",
              "name": "maxBeds",
              "variableName": "maxBeds"
            },
            {
              "kind": "Variable",
              "name": "maxPrice",
              "variableName": "maxPrice"
            },
            {
              "kind": "Variable",
              "name": "minBeds",
              "variableName": "minBeds"
            },
            {
              "kind": "Variable",
              "name": "minPrice",
              "variableName": "minPrice"
            },
            {
              "kind": "Variable",
              "name": "offMlsOnly",
              "variableName": "offMlsOnly"
            },
            {
              "kind": "Variable",
              "name": "propertyTypes",
              "variableName": "forSalePropertyTypes"
            },
            {
              "kind": "Variable",
              "name": "sortOrder",
              "variableName": "sortOrder"
            },
            {
              "kind": "Variable",
              "name": "statuses",
              "variableName": "forSaleStatuses"
            }
          ],
          "concreteType": "ForSaleInventoryConnection",
          "kind": "LinkedField",
          "name": "searchForSaleInventory",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PageInfo",
              "kind": "LinkedField",
              "name": "pageInfo",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasNextPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endCursor",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "hasPreviousPage",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startCursor",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "totalCount",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ForSaleInventoryEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "__typename",
                      "storageKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "ForSalePropertySearchResult_forSalePropertyV5"
                        }
                      ],
                      "type": "ForSalePropertyV5",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "DevelopmentUnitSearchResult_newDevelopmentSampleUnit"
                        }
                      ],
                      "type": "DevelopmentProjectSampleUnit",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "args": null,
                          "kind": "FragmentSpread",
                          "name": "DevelopmentProjectSearchResult_developmentProject"
                        }
                      ],
                      "type": "DevelopmentProject",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})());
}

let node = makeNode(PropertiesPageRelayInventoryRefetchQuery_graphql.node);

let wrap_fragment_searchForSaleInventory_edges_node = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_fragment_searchForSaleInventory_edges_node = unwrap_fragment_searchForSaleInventory_edges_node;
exports.wrap_fragment_searchForSaleInventory_edges_node = wrap_fragment_searchForSaleInventory_edges_node;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
